import { useState } from "react";
import { portalLink } from "../utils/portal";

function Partners() {
  const [hovered, setHovered] = useState(null);

 const btnStyle = (id) => ({
  fontSize: "0.68rem",
  padding: "0.65rem 1.4rem",
  color: hovered === id ? "#c84b20" : undefined,
  backgroundColor: hovered === id ? "#ffffff" : undefined,
});

  return (
    <section className="partners" id="partners">
      <div className="eyebrow rv">
        <div className="eyebrow-dash"></div>
        <span className="eyebrow-text">Our Ecosystem</span>
      </div>
      <h2 className="sec-title lt rv d1">Built on <em>Partnerships.</em></h2>
      <div className="p-cards">
        <div className="pcard rv d2">
          <div className="pcard-icon">
            <span style={{ fontSize: "2rem", lineHeight: 1, color: "#c84b20" }}>⬡</span>
          </div>
          <h3 className="pcard-title">Hiring Partners</h3>
          <p className="pcard-desc">
            Architecture firms, studios, and construction organizations — join
            the IPDI hiring ecosystem and access a curated, industry-ready
            talent pool from across India.
          </p>
          
          <a  href={portalLink("/company-login")}
            className="btn btn-outlt"
            style={btnStyle("hiring")}
            onMouseEnter={() => setHovered("hiring")}
            onMouseLeave={() => setHovered(null)}
          >Become a Hiring Partner</a>
          <br /><span className="pcard-label">For Firms &amp; Studios</span>
        </div>
        <div className="pcard rv d3">
          <div className="pcard-icon">
            <span style={{ fontSize: "2rem", lineHeight: 1, color: "#c84b20" }}>⬢</span>
          </div>
          <h3 className="pcard-title">College Partners</h3>
          <p className="pcard-desc">
            Architecture and design colleges — become an IPDI placement partner
            and connect your graduates with leading firms and organizations
            nationwide.
          </p>
          
          <a href={portalLink("/college-register")}
            className="btn btn-outlt"
            style={btnStyle("college")}
            onMouseEnter={() => setHovered("college")}
            onMouseLeave={() => setHovered(null)}
          >Become a College Partner</a>
          <br /><span className="pcard-label">For Institutions</span>
        </div>
      </div>
    </section>
  );
}

export default Partners;
